// @flow

import type { State } from '../reducers';
import { getMostImportantMethod } from '../../../helpers';

type GlobalState = {
  configuratorSettings: State,
};

export const getConfiguratorSettings = (state: any): State => {
  const { configuratorSettings } = state;
  if (!configuratorSettings) {
    throw new Error('Missing configuratorSettings store.');
  }
  return configuratorSettings;
};

type BestsellerLabel = $PropertyType<State, 'bestseller_label'>;
export const getBestsellerLabel = (state: GlobalState): BestsellerLabel => (
  getConfiguratorSettings(state).bestseller_label
);

type PriceLabel = $PropertyType<State, 'price_label'>;
export const getPriceLabel = (state: GlobalState): PriceLabel => (
  getConfiguratorSettings(state).price_label
);

type BasePriceLabel = $PropertyType<State, 'baseprice_label'>;
export const getBasePriceLabel = (state: GlobalState): BasePriceLabel => (
  getConfiguratorSettings(state).baseprice_label
);

type SoldOutLabel = $PropertyType<State, 'sold_out_text'>;
export const getSoldOutLabel = (state: GlobalState): SoldOutLabel => (
  getConfiguratorSettings(state).sold_out_text
);

type InStockText = $PropertyType<State, 'in_stock_text'>;
export const getInStockText = (state: GlobalState): InStockText => (
  getConfiguratorSettings(state).in_stock_text
);

type NonRecurringText = $PropertyType<State, 'non_recurring_text'>;
export const getNonRecurringText = (state: GlobalState): NonRecurringText => (
  getConfiguratorSettings(state).non_recurring_text
);

type InPackage = $PropertyType<State, 'in_package'>;
export const getInPackage = (state: GlobalState): InPackage => (
  getConfiguratorSettings(state).in_package
);

type InBundle = $PropertyType<State, 'in_bundle'>;
export const getInBundle = (state: GlobalState): InBundle => (
  getConfiguratorSettings(state).in_bundle
);

export const getAlternativePriceString = (state: GlobalState, activeMethods: string[]): string => {
  const method = getMostImportantMethod(activeMethods);
  if (method === 'bundle') {
    return getInBundle(state);
  }
  if (method === 'package') {
    return getInPackage(state);
  }
  return '';
};

type MileageAbbreviation = $PropertyType<State, 'mileage_abbreviation'>;
export const getMileageAbbreviation = (state: GlobalState): MileageAbbreviation => (
  getConfiguratorSettings(state).mileage_abbreviation
);

type ContractDurationAbbreviation = $PropertyType<State, 'contract_duration_abbreviation'>;
export const getContractDurationAbbreviation = (
  state: GlobalState,
): ContractDurationAbbreviation => (
  getConfiguratorSettings(state).contract_duration_abbreviation
);

type DeliveryTimeDurationSingle = $PropertyType<State, 'delivery_time_duration_single'>;
export const getDeliveryTimeDurationSingle = (state: GlobalState): DeliveryTimeDurationSingle => (
  getConfiguratorSettings(state).delivery_time_duration_single
);

type DeliveryTimeDurationPlural = $PropertyType<State, 'delivery_time_duration_plural'>;
export const getDeliveryTimeDurationPlural = (state: GlobalState): DeliveryTimeDurationPlural => (
  getConfiguratorSettings(state).delivery_time_duration_plural
);

type OrderButtonsInformationText = $PropertyType<State, 'order_buttons_information_text'>;
export const getOrderButtonsInformationText = (state: GlobalState): OrderButtonsInformationText => (
  getConfiguratorSettings(state).order_buttons_information_text
);

type FastDeliveryDurationSingle = $PropertyType<State, 'fast_delivery_time_duration_single'>;
export const getFastDeliveryTimeDurationSingle = (
  state: GlobalState,
): FastDeliveryDurationSingle => (
  getConfiguratorSettings(state).fast_delivery_time_duration_single
);

type FastDeliveryDurationPlural = $PropertyType<State, 'fast_delivery_time_duration_plural'>;
export const getFastDeliveryTimeDurationPlural = (
  state: GlobalState,
): FastDeliveryDurationPlural => (
  getConfiguratorSettings(state).fast_delivery_time_duration_plural
);

type LongMileageLabel = $PropertyType<State, 'mileage'>;
export const getLongMileageLabel = (state: GlobalState): LongMileageLabel => (
  getConfiguratorSettings(state).mileage
);
